import { apiQWorkardsEnvironment } from '@qaroni-env/environment';

// TODO: refactor without Q
export const ApiQWorkardsEnv = {
  baseUrl: Object.prototype.hasOwnProperty.call(
    apiQWorkardsEnvironment,
    'baseUrl'
  )
    ? apiQWorkardsEnvironment.baseUrl
    : null,
  baseWorkstationUrl: Object.prototype.hasOwnProperty.call(
    apiQWorkardsEnvironment,
    'baseWorkstationUrl'
  )
    ? apiQWorkardsEnvironment.baseWorkstationUrl
    : null,
};
